export default "__VITE_ASSET__UZtTsB7H__"